import { render, staticRenderFns } from "./FamilyTagRadarChartSkeleton.vue?vue&type=template&id=5a442320&scoped=true&"
import script from "./FamilyTagRadarChartSkeleton.vue?vue&type=script&lang=js&"
export * from "./FamilyTagRadarChartSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a442320",
  null
  
)

export default component.exports